import ApiManager from '@/utils/ApiManager'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  // ADMP同期中はtrue
  proccesing: false,
}

const getters = {
  get: state => state,
}

const actions = {
  /**
   * ADMP同期を行う
   */
  sync ({commit}) {
    commit('setProccesingFlag', true)

    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['util'],
        ['v1AdmpSync'],
        [{}])
        .then(res => {
          console.log('v1AdmpSync', res)
          let status = Utility.parseResponse(res)

          if (status.result) {
            setTimeout(() => {
              commit('setProccesingFlag', false)
              console.log('ADMP同期完了')
              resolve()
            }, 2000)
            // commit('setProccesingFlag', false)
            // console.log('ADMP同期完了')
            // resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
}

const mutations = {
  setProccesingFlag (state, flag) {
    Vue.set(state, 'proccesing', flag)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
